import { Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { guest as GuestAPI, GUEST_IN_USE_BEAT_MS } from '../api/guest.js';
import { useFeatureFlagsContext } from '../context/FeatureFlagContext';
import { useNotifications } from '../context/NotificationsContext.jsx';
import { PublicHeader } from '../components/snippets/public-header.snippet.jsx';
import { LoadingState } from '../components/blocks/loading-state.block.jsx';
import Footer from './Footer';
import { RefusalNotice } from '../components/blocks/refusal-notice.block.jsx';

export default function GuestLayout({ children }) {
  useFeatureFlagsContext();
  useNotifications();
  const location = useLocation();
  const hidePublicHeader = location.pathname === '/';
  // "Somebody is in this guest session right now" — on EVERY guest page, not
  // only the conversation. The report page, where a person waits ten minutes
  // for a document, had no beat, so a signed-in tab elsewhere on this browser
  // could convert the session and the report answered 404 mid-write. See
  // GuestAPI.markInUse.
  const onGuestRoute = location.pathname.startsWith('/guest/');
  const guestProjectId = (location.pathname.match(/^\/guest\/requirements\/v2\/([^/]+)/) || [])[1] || '';
  useEffect(() => {
    if (!onGuestRoute) return undefined;
    GuestAPI.markInUse(guestProjectId);
    const id = setInterval(() => GuestAPI.markInUse(guestProjectId), GUEST_IN_USE_BEAT_MS);
    return () => { clearInterval(id); GuestAPI.clearInUse(); };
  }, [onGuestRoute, guestProjectId]);
  return (
    <div className="flex min-h-screen w-full flex-col bg-[var(--moksy-canvas)]">
      <a href="#guest-main-content" className="skip-link">
        Skip to main content
      </a>

      {!hidePublicHeader && <PublicHeader />}
      <RefusalNotice />

      <main id="guest-main-content" tabIndex="-1" className="flex-1 focus:outline-none">
        <div className="mx-auto w-full max-w-[1600px] px-4 py-4 md:px-6 md:py-6 lg:px-8 lg:py-8">
          {/* Inner Suspense: the header + footer persist while a lazy page
              loads; only this content region shows the loader. */}
          <Suspense fallback={<LoadingState label="Loading…" />}>
            {children}
          </Suspense>
        </div>
      </main>

      {/* Public pages get the fat marketing footer; the authed app uses the
          lean default. Same component, different variant (see AppFooter). */}
      <Footer variant="marketing" />
    </div>
  );
}
